import { useEffect } from "react";

const BASE = "https://seklartut.se";
const DEFAULTS = {
  title: "Fönsterputs & utvändig rengöring i Skaraborg – Se Klart Ut",
  description: "Fönsterputs, solpaneltvätt, altantvätt & marktvätt i hela Skaraborg. Kostnadsfri offert, försäkrat och Se Klart Ut-garanti.",
};

const setMeta = (selector, attr, content) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [kind, name] = attr;
    el.setAttribute(kind, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

/** Lightweight per-route SEO (title, description, canonical, og) without extra dependencies. */
export const Seo = ({ title, description, path = "/", noindex = false }) => {
  useEffect(() => {
    document.title = title || DEFAULTS.title;
    setMeta('meta[name="description"]', ["name", "description"], description || DEFAULTS.description);
    setMeta('meta[name="robots"]', ["name", "robots"], noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
    setMeta('meta[property="og:title"]', ["property", "og:title"], title || DEFAULTS.title);
    setMeta('meta[property="og:description"]', ["property", "og:description"], description || DEFAULTS.description);
    setMeta('meta[property="og:url"]', ["property", "og:url"], `${BASE}${path}`);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${BASE}${path}`);
  }, [title, description, path, noindex]);
  return null;
};

export default Seo;
